export default __webpack_public_path__ + "static/1-9ac7219bf584d90c65c10ac3ffc62024.png";